import Actions from './actions/PluginSetup'
import Details from './detail/PluginSetup'
import AisleHeatmappingCardDataViewer from './AisleHeatmappingCardDataViewer'
import AisleSessionEventsDataViewer from './AisleSessionEventsDataViewer'
import AisleSessionSupportDataViewer from './AisleSessionSupportDataViewer'

export default {
  install( molten ) {    
    Actions.install( molten )
    Details.install( molten )
    molten.addPlugin( 'DataViewer', AisleHeatmappingCardDataViewer )
    molten.addPlugin( 'DataViewer', AisleSessionEventsDataViewer )
    molten.addPlugin( 'DataViewer', AisleSessionSupportDataViewer )
  },
}
